export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20editorial%20flatlay%20of%20diverse%20fashion%20and%20lifestyle%20products%20beautifully%20styled%20on%20warm%20cream%20textured%20surface%2C%20sneakers%2C%20hoodie%2C%20accessories%2C%20sunglasses%20and%20small%20plants%20arranged%20in%20organic%20flowing%20composition%2C%20soft%20natural%20daylight%20from%20window%2C%20sage%20green%20and%20terracotta%20color%20accents%2C%20high-end%20magazine%20editorial%20aesthetic%2C%20gentle%20shadows%20creating%20depth%2C%20clean%20balanced%20layout%20with%20breathing%20space&width=1800&height=1200&seq=hero-bg-v2-01&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/30 to-background-50/95"></div>

      <div className="relative z-10 w-full max-w-[800px] mx-auto px-4 md:px-6 text-center py-16 md:py-24">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6">
          Kakobuy Spreadsheet Polska – Największa baza produktów i najlepszych Finds
        </h1>
        <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8 max-w-[640px] mx-auto">
          Znajdź tysiące produktów Kakobuy w jednym miejscu. Nasza lista Spreadsheet pomaga szybciej odkrywać najlepsze produkty, porównywać opcje i podejmować lepsze decyzje zakupowe.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Kakobuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 rounded-md text-base font-semibold hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Kup teraz
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5">
          <div className="flex items-center gap-2 text-sm text-foreground-600">
            <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
            <span>Aktualizowane listy produktów</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-600">
            <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
            <span>Szczegółowe poradniki</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-600">
            <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
            <span>Porównania produktów</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-600">
            <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
            <span>Bezpieczeństwo zakupów</span>
          </div>
        </div>
      </div>
    </section>
  );
}